import { render } from "./ComponentInfo.vue?vue&type=template&id=7020f72f&scoped=true"
import script from "./ComponentInfo.vue?vue&type=script&lang=js"
export * from "./ComponentInfo.vue?vue&type=script&lang=js"

import "./ComponentInfo.vue?vue&type=style&index=0&id=7020f72f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7020f72f"]])

export default __exports__